<template>
  <div id="barMap" v-loading="loading" :style="{ 'height': isDetail ? '337px' : '284px' }"></div>
</template>

<script>
import echarts from 'echarts'
import api from '@/services/api/statistics/statistics'
export default {
  props: {
    rangeTime: {
      type: [Array, Object],
      default: []
    },
    projectId: {
      type: [Number, String],
      default: 0
    },
    // 是否为详情页面引用的组件
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      opation: {
        legend: {
          textStyle: { fontSize: 12, color: "rgba(32, 32, 32, .6)" },
          icon: 'circle',
          itemWidth: 8,
          left: 126,
          bottom: 0,
          itemGap: 28
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          extraCssText: 'box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);',
          padding: 16,
          textStyle: {
            color: 'initial'
          },
          formatter: (value) => {
            return this.getTipItem(value)
          }
        },
        color: ['#73B2FF', '#FFDA90', '#FF9393', '#D8D8D8'],
        dataset: {
          source: [
            ['product', '已完成', '未完成', '已逾期', '已归档']
          ]
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: "rgba(32, 32, 32, .6)"
            }
          },
          axisLabel: {
            interval: 0,
            // width: 50,
            // overflow: "truncate",
            formatter: function(params) {
              //  console.log('formatter', params, params.length)
              var newParamsName = ''// 最终拼接成的字符串
              var paramsNameNumber = params.length// 实际标签的个数
              var provideNumber = 6// 每行能显示的字的个数
              // 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
              if (paramsNameNumber > provideNumber) {
              // ********重点在这里********
                newParamsName = params.substring(0, 5) + '..'// 最终拼成的字符串
              } else { // 将旧标签的值赋给新标签
                newParamsName = params
              }
              // 将最终的字符串返回
              return newParamsName
            }
          },
          axisTick: {
            lineStyle: {
              color: 'rgba(32, 32, 32, 0.08)'
            }
          },
        },
        yAxis: {
          type: 'value',
          axisTick: {
            lineStyle: {
              color: 'rgba(32, 32, 32, 0.08)'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(32, 32, 32, .6)"
            }
          }
        },
        grid: {
          containLabel: true,
          top: 34,
          left: 0,
          right: 0,
          bottom: 45
        },
        series: [
          { type: 'bar', barMaxWidth: 10 },
          { type: 'bar', barMaxWidth: 10 },
          { type: 'bar', barMaxWidth: 10 },
          { type: 'bar', barMaxWidth: 10 },
        ]
      },
    }
  },
  watch: {
    rangeTime: {
      handler() {
        this.gettaskCompletionOverview()
      },
      deep: true
    },
    projectId(val) {
      if (val) {
        // this.init()
        this.gettaskCompletionOverview()
      }
    }
  },
  mounted() {
    // this.init()
    if (this.isDetail && this.rangeTime.length) {
      this.gettaskCompletionOverview()
    }
  },
  methods: {
    init() {
      if (this.isDetail) {
        // 详情页面引用，需要对echarts的参数进行修改
        this.opation.legend.left = 'center'
        this.opation.legend.top = 48

        this.opation.grid = {
          top: 92,
          left: 74,
          right: 74,
          bottom: 70
        }
        this.opation.series = [
          { type: 'bar', barMaxWidth: 18 },
          { type: 'bar', barMaxWidth: 18 },
          { type: 'bar', barMaxWidth: 18 },
          { type: 'bar', barMaxWidth: 18 },
        ]
      }
      var myChart = echarts.init(document.getElementById('barMap'));
      myChart.clear()
      myChart.setOption(this.opation)
      myChart.on('click', 'series', () => {
        this.$emit('mapClick')
      })
    },
    getTipItem(value) {
      let str = `<div class="tool-title">${value[0].name}</div>`
      value.forEach((res, index) => {
        let data = `
          <div class="tool-title-item">
            <p class="tool-title-item---left">
              <span class="bg" style="background:${res.color};"></span>
              <span>${res.seriesName}</span>
            </p>
            <p class="tool-title-item---right">${res.data[index + 1]}</p>
          </div>
        `
        str = str + data
      })
      return str
    },
    gettaskCompletionOverview() {
      this.loading = true
      let params = {
        project_id: this.projectId,
        start_time: this.rangeTime[0],
        end_time: this.rangeTime[1]
      }
      api.taskCompletionOverview(params).then(res => {
        this.loading = false
        let arr = [['product', '已完成', '未完成', '已逾期', '已归档']]
        res.forEach(item => {
          for (let key in item) {
            arr.push([
              key,
              item[key].completed_number_of_tasks,
              item[key].undone_number_of_tasks,
              item[key].overdue_number_of_tasks,
              item[key].archived_number_of_tasks
            ])
            // arr.push([
            //   key,
            //   1,
            //   2,
            //   5,
            //   20
            // ])
          }
        })
        this.opation.dataset.source = arr

        if (res.length > 5 && !this.isDetail) {
          // 数据超过5条之后，显示滑动条可供滑动查看
          this.opation.dataZoom = {
            type: 'slider',
            height: 12,
            bottom: 28,
            showDetail: false,
            showDataShadow: false,
            end: 20,
            minValueSpan: 5,
            backgroundColor: "#E6E6E6",
            fillerColor: "#D5D5D5",
            handleStyle: {
              opacity: 0
            }
          }
        } else {
          delete this.opation.dataZoom
        }
        this.init()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
#barMap {
  width: 100%;
  height: 100%;
}
::v-deep {
  .tool-title {
    width: 150px;
    @include ellipsis();
  }
  .tool-title-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: rgba(32, 32, 32, 0.4);
    margin-top: 6px;
    .tool-title-item---left {
      display: flex;
      align-items: center;
      .bg {
        margin-right: 8px;
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
      }
    }
    .tool-title-item---right {
      color: rgba(25, 24, 67, 0.8);
    }
  }
}
</style>
